<template>
  <v-navigation-drawer v-model="drawer.open" fixed right temporary width="340">
    <template v-slot:prepend>
      <v-toolbar>
        <v-btn icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title class="subtitle-1">
          {{ $t("datas") }}
        </v-toolbar-title>
      </v-toolbar>
    </template>

    <div>
      <div class="pa-4 text-center">
        <v-avatar class="mb-2" color="grey darken-4" size="88">
          <v-icon :color="level.color" dark size="60">
            {{ level.icon }}
          </v-icon>
        </v-avatar>
        <div class="overline" :class="`${level.color}--text`">
          {{ level.name }}
        </div>
        <div class="headline">
          {{ drawer.data.dados.nome }}
        </div>
        <div class="subtitle-2">{{ drawer.data.dados.login }}</div>
        <v-row no-gutters class="mt-2">
          <v-col cols="4" v-if="drawer.data.dados.celular">
            <v-btn
              :class="$vuetify.theme.dark ? 'grey darken-2' : 'grey lighten-2'"
              icon
              :href="`tel:+55${drawer.data.dados.celular}`"
              target="_blank"
            >
              <v-icon>mdi-phone</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="4" v-if="drawer.data.dados.celular">
            <v-btn
              :class="$vuetify.theme.dark ? 'grey darken-2' : 'grey lighten-2'"
              icon
              :href="
                `https://wa.me/+55${drawer.data.dados.celular}?text=Olá ${drawer.data.dados.nome}`
              "
              target="_blank"
            >
              <v-icon>mdi-whatsapp</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="4" v-if="drawer.data.dados.email">
            <v-btn
              :class="$vuetify.theme.dark ? 'grey darken-2' : 'grey lighten-2'"
              icon
              :href="`mailto:${drawer.data.dados.email}`"
            >
              <v-icon>mdi-email</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-item
        :class="
          $vuetify.theme.dark ? 'grey darken-3 mb-2' : 'grey lighten-3 mb-2'
        "
        v-for="(value, name) in drawer.data.dados"
        :key="name"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{
              name == "limite_retençao" &&
              $store.state.operator &&
              $store.state.operator.retail == 1
                ? $t("agentBalance")
                : name | formatName
            }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action-text>
          <span v-if="name !== variableCommissionsLabel">
            {{ checkValueBoolean(name, value) }}
          </span>
          <v-btn
            v-else
            x-small
            text
            color="primary"
            @click="seeVariableCommissions"
          >
            {{ $t("toView") }}
          </v-btn>
        </v-list-item-action-text>
      </v-list-item>

      <!-- 

        Handler Routes to view "Collectors"

      -->
      <template v-if="drawer.data.routesCollectors">
        <v-subheader class="overline">{{ $t("linkedRoutes") }}</v-subheader>
        <v-alert
          v-show="drawer.data.routesCollectors.length == 0"
          type="warning"
          class="ma-4"
          dense
        >
          {{ $t("noRouteLinked") }}
        </v-alert>
        <v-list-item
          :class="
            $vuetify.theme.dark ? 'grey darken-3 mb-2' : 'grey lighten-3 mb-2'
          "
          v-for="(item, index) in drawer.data.routesCollectors"
          :key="index"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $t("route") }}:</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action-text>
            {{ item.nome }} ({{ item.id }})
          </v-list-item-action-text>
        </v-list-item>
      </template>

      <!-- 

        Handler Agents to views "Routes"
        
      -->
      <template v-if="drawer.data.agentsAttachRoute">
        <v-subheader class="overline">{{ $t("linkedAgents") }}</v-subheader>
        <v-alert
          v-show="drawer.data.agentsAttachRoute.length == 0"
          type="warning"
          class="ma-4"
          dense
        >
          {{ $t("noAgentLinked") }}
        </v-alert>
        <v-list-item
          :class="
            $vuetify.theme.dark ? 'grey darken-3 mb-2' : 'grey lighten-3 mb-2'
          "
          v-for="(item, index) in drawer.data.agentsAttachRoute"
          :key="index"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $t("agent") }}:</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action-text>
            {{ item.nome }} ({{ item.id }})
          </v-list-item-action-text>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: "drawer-profile",
  data: () => ({
    level: {
      name: "name",
      icon: "mdi-account",
      color: "white",
    },
  }),
  computed: {
    drawer() {
      return this.$store.state.drawerProfile;
    },
    variableCommissionsLabel() {
      return this.$t("variableCommissions.label");
    },
    isAffiliatedAndHasVariableCommission() {
      return (
        this.drawer.data.dados.level == "2" &&
        this.drawer.data.dados.commission_type == "2"
      );
    },
  },
  watch: {
    drawer() {
      if (this.isAffiliatedAndHasVariableCommission) {
        if (localStorage.getItem("level") === "administrator") {
          this.drawer.data.dados = {
            ...this.drawer.data.dados,
            [this.variableCommissionsLabel]: true,
          };
        }

        this.drawer.data.dados = {
          ...this.drawer.data.dados,
          comissao_online: this.$t("variable"),
        };
      }

      this.getObjLevel();
    },
  },
  methods: {
    checkValueBoolean(name, value) {
      if (name === "commission_type") {
        return value == 2
          ? this.$t("variableCommissionSingular")
          : this.$t("fixedCommission");
      }

      const keys = [
        "ativo",
        "status",
        "visualizar_premiada",
        "visualizar_ao_vivo",
        "auto_premio",
        "limitar_agente",
        "premiar_aposta",
        "creditar_agente",
      ];
      if (keys.includes(name)) {
        return value == 1 ? this.$t("yes") : this.$t("no");
      }
      return value;
    },
    close() {
      var open = this.drawer.open;
      this.$store.commit("showDrawerProfile", {
        open: !open,
        data: { dados: { nome: "", login: "" } },
      });
    },
    // HANDLER LEVEL UI
    getObjLevel() {
      let level = this.drawer.data.dados.level;

      if (this.drawer.data.dados.ultimo_login) {
        this.drawer.data.dados.ultimo_login = new Date(
          this.drawer.data.dados.ultimo_login
        ).toLocaleString();
      }

      // Collector and Routes Handle
      // quando não existe level, entra aqui
      // aqui eu pego algumas chaves únicas para rota e coletor;
      if (!level) {
        level = this.drawer.data.routesCollectors ? 21 : "0";
      }

      if (level == "0") {
        level = this.drawer.data.agentsAttachRoute ? 31 : "0";
      }

      if (level == "0") {
        return;
      }

      // Users Level Handle
      const obj = {
        4: {
          icon: "mdi-account-tie",
          color: "orange",
          name: this.$t("regionalManager"),
        },
        3: {
          icon: "mdi-account-multiple",
          color: "green",
          name: this.$t("localManager"),
        },
        2: {
          icon: "mdi-account",
          color: "blue",
          name: this.$t("affiliate"),
        },
        21: {
          icon: "mdi-account-cash",
          color: "light-green",
          name: this.$t("collector"),
        },
        31: { icon: "mdi-map", color: "lime", name: this.$t("route") },
      };
      return (this.level = obj[level]);
    },
    formatValue(val) {
      if (val == 0) {
        return this.$t("no");
      }
      if (val == 1) {
        return this.$t("yes");
      }
      return val;
    },

    seeVariableCommissions() {
      this.$root.$emit("openVariableCommissions");
    },
  },
  filters: {
    formatName(val) {
      var name = val.replace("_", " ");
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
  },
};
</script>
